import React from "react";

const taxCalInput = props => {
  return (
    <div style={styles.container}>
      <div style={styles.headingStyle}>
        <div style={styles.headingContent}>
          {props.heading}
          {props.currency}
        </div>
      </div>

      <input
        type="number"
        onChange={props.storeValue}
        style={styles.inputStyle}
      />
    </div>
  );
};
export default taxCalInput;

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 10
  },
  inputStyle: {
    width: "60%",
    borderWidth: 3,
    border: "solid",
    borderColor: "#aaa",
    height: 30,
    borderRadius: 20,
    outline: "none",
    paddingLeft: 7
  },
  headingStyle: {
    justifyContent: "center",
    alignItems: "center",
    width: "40%",
    borderColor: "#ccc"
  },
  headingContent: {
    fontWeight: "bold",
    display: "flex",
    flexDirection: "row",
    marginTop: 9
  }
};
